import {
  SET_LOADING,
  SET_DEVICE_HEIGHT,
  SET_ERROR_STATE,
  SET_ADDITIONAL_INFO,
} from 'redux/actions/types';

import { TOKEN, Sentry } from 'utils';
import apiService from 'utils/ApiService';

const { billerService, setBearer } = apiService.getInstance();

export const setLoading = val => ({
  type: SET_LOADING,
  payload: val,
});

export const setErrorState = val => ({
  type: SET_ERROR_STATE,
  payload: val,
});

export const setDeviceHeight = val => ({
  type: SET_DEVICE_HEIGHT,
  payload: val,
});

export const setAdditionalInfo = val => ({
  type: SET_ADDITIONAL_INFO,
  payload: val,
});

export const getAuthToken = params => async dispatch => {
  let resolve = null;
  const token = TOKEN.getAccessToken();
  try {
    dispatch(setLoading(true));
    // Check Is Token IsNot in Session
    if (!token) {
      if (params.auth_code && (params.state || params.request_id)) {
        // Check Token Is Available
        const response = await billerService.post('auth/dana', params);

        // Check Status Request
        if (response.status === 200) {
          const { payload, status } = response.data;
          // Check Status Auth Token Success
          if (status === 'success') {
            // Clean Token
            TOKEN.removeAccessToken();
            // Set Token To Storage
            TOKEN.setToken(payload.auth_token);
            // Set Token To API Service
            setBearer(payload.auth_token);
            resolve = Promise.resolve(payload.auth_token);
          } else {
            throw new Error(404);
          }
        } else {
          throw new Error(400);
        }
      } else {
        // Determine on sentry if params not set
        throw new Error('INVALID_PARAM');
      }
    } else {
      TOKEN.removeAccessToken();
      // Set Token To Storage
      TOKEN.setToken(token);
      // Set Token To API Service
      setBearer(token);
      resolve = Promise.resolve(token);
    }
    dispatch(setLoading(false));
  } catch (error) {
    Sentry.captureMessage(error);
    resolve = Promise.reject(error);
    dispatch(setLoading(false));
  }
  return resolve;
};
